/*
 * Created by Joseph Saliba on 2/17/18.
 */
import { Factory } from '../../services/Factory';

interface IBurnDownChartScope extends angular.IScope {
  rows: Array<any>;
  columns: Array<Array<any>>;
  types;
  lastRecordedDate: number;
  projectionSeriesName: string;
  width: string;
  height: string;
}

interface IBurnDownChartAttributes extends angular.IAttributes {
}

export class BurnDownChart implements angular.IDirective {
  public restrict: string = 'E';
  public link: (scope: IBurnDownChartScope, element: angular.IAugmentedJQuery, attrs: IBurnDownChartAttributes) => void;
  public template: string;
  public scope = {
    rows: '=',
    columns: '=',
    types: '=',
    lastRecordedDate: '=',
    projectionSeriesName: '@',
    width: '@',
    height: '@'
  };

  constructor() {
    this.template = `<div></div>`;
    this.link = (scope: IBurnDownChartScope, element: angular.IAugmentedJQuery, attrs: IBurnDownChartAttributes) => {
        scope.$watchGroup(['rows', 'columns', 'types'], () => {
          scope.columns.unshift(scope.rows);

          const start = _.find(scope.rows, d => d >= scope.lastRecordedDate);
          const regions = {};

          regions[scope.projectionSeriesName] = [{start, style: 'dashed'}];

          c3.generate({
            bindto: element[0],
            size: {
              height: scope.height ? +scope.height : 460,
              width: +scope.width
            },
            data: {
              x: scope.columns[0][0],
              columns: scope.columns as any,
              type: 'bar',
              types: scope.types,
              regions
            },
            transition: {
              duration: 0
            },
            color: {
              pattern: ['#0099CC', '#FF8800', '#007E33', '#3F729B']
            },
            axis: {
              x: {
                localtime: true,
                type: 'timeseries',
                tick: {
                  format: '%Y-%m-%d',
                  culling: {
                    max: 50
                  },
                  rotate: 50,
                  multiline: false
                }
              },
              y: {
                min: 0,
                padding: {
                  bottom: 0
                },
                tick: {
                  format: r => d3.format(',d')(r)
                }
              }
            },
            grid: {
              x: {
                show: false
              },
              y: {
                show: false
              }
            },
            zoom: {
              enabled: false
            },
            subchart: {
              show: false
            }
          });
        });
    }
  }
}

frontendApp.directive("iioBurnDownChart", [Factory.Create(BurnDownChart)]);
